import React, { useState, useEffect } from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseIcon from "@mui/icons-material/Close";
import "./Menu.css";
import { H2LARGER, H3, P } from "../components/Text";
import { KofiButton } from "react-kofi-button";
import License from "./License";

//hamburger menu for welcome page, all question pages and results page.
const Menu = () => {
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen(!open);
  }

  return (
    <>
      <div className="menu-icon-container">
        <MenuRoundedIcon
          onClick={() => {
            toggleOpen();
          }}
          sx={{ fontSize: 35, color: "white" }}
        />
      </div>
      {open && (
        <div
          id="background"
          onClick={() => {
            toggleOpen();
          }}
          className="background"
        >
          <div id="menu-container" className="menu-container">
            <div className="header">
              <div className="menu-text">
                <H2LARGER>About</H2LARGER>
              </div>
            </div>
            <div className="about-container">
              <P style={{ marginTop: "0px !important" }}>
                The 'Pick & Mix Personalised Pride Flag Project' was created as
                a fun afternoon's activity to try and combine the splendid array
                of Pride flags into a single system to allow a person's unique
                place in the rainbow community to be expressed with a single
                flag.
              </P>
              <P>
                Feel free to share and modify your flags as per license below,
                and if you have any suggestions or feedback, we'd love to hear
                from you!
              </P>
              <License />
            </div>

            <div className="kofi-button-container">
              <KofiButton
                backgroundColor="#794bc4"
                username="prideflagproject"
                label="Support Us!"
              />
            </div>
            <div className="close-icon-container">
              <div className="close-icon">
                <CloseIcon
                  onClick={() => {
                    toggleOpen();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Menu;
